import type { DocumentByIdResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetDocumentByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetDocumentByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

import { mapTrpcDocumentToGraphQL } from './useGetDocumentById';

type UseLazyGetDocumentByIdArgs = {
  documentId: string;
};

export const useLazyGetDocumentById = createLazyQueryHook<
  UseLazyGetDocumentByIdArgs,
  DocumentByIdResponseRow[],
  GetDocumentByIdQuery
>({
  trpcQuery: (client, { documentId }) =>
    client.frontend.document.documentById.query({ documentId }),
  mapTrpcDataToGraphQL: (data) => ({
    document: data.map(mapTrpcDocumentToGraphQL),
  }),
  graphqlDocument: GetDocumentByIdDocument,
  graphqlVariables: ({ documentId }) => ({ id: documentId }),
  graphqlFetchPolicy: 'no-cache',
});
